import { Images } from '@/assets/imgs';
import { LinkButton } from '@/components/Buttons';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useRef } from 'react';

export const PrometheusChestplate = () => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);
  return (
    <div className="prometheus-chestplate">
      <div className="container flex middle center">
        <Image
          src={Images.prometheusNFT.chestplate}
          className="chestplate"
          width={422}
          height={422}
          quality={100}
          alt="chestplate"
        />

        <div className="flex column content">
          <span className="lexend-body-s">The Prometheus Chestplate NFT</span>
          <div className="flex column title integralfc-h1">
            <span>Suit up</span>
            <span>Soldier</span>
          </div>
          <div className="description">
            Our secondary NFT collection, granting holders a 20% discount for
            our XBG Presale and ecosystem benefits, such as launchpad
            allocations equivalent to holding 5,000 XBG.
          </div>

          <LinkButton
            text="View Collection"
            to="https://magiceden.io/collections/polygon/0x23fd902c24e089c58a583ed0cbd929bf2f6b339f"
          />
        </div>
      </div>
    </div>
  );
};
